import React from 'react';

interface SlotChipProps {
  time: string; // ISO 8601 string
  isSelected: boolean;
  onClick: () => void;
  timezone?: string;
}

export const SlotChip: React.FC<SlotChipProps> = ({ time, isSelected, onClick, timezone }) => {
  const formatTime = (isoString: string) => {
    const date = new Date(isoString);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: timezone || 'UTC',
    });
  };

  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 rounded-lg text-sm font-medium transition-all focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-1 ${
        isSelected
          ? 'bg-purple-600 text-white shadow-md'
          : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
      }`}
    >
      {formatTime(time)}
    </button>
  );
};
